<template>
    <div>
        <div class="title">
            <h4 class="mb-0">List of Devices</h4>
        </div>
        <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn" @click="openAddDevice">
                <spinner v-if="isLoadingAddModal" />
                <span v-else>Add Device</span>
            </button>
            <button type="button" class="btn" @click="getDeviceList">
                <spinner v-if="isLoadingSyncModal" />
                <span v-else>Sync Devices</span>
            </button>
        </div>
        <div>
            <LoaderList v-if="isLoading" class="w-100" />
            <div v-else class="table-responsive">
                <table class="table list">
                    <thead>
                        <tr>
                            <th>Manufacturer:</th>
                            <th>Device:</th>
                            <th>Display Name:</th>
                            <th>Status:</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="devices && devices.length">
                        <template v-for="device in devices">
                            <tr
                                :key="'row-' + device.id"
                                :id="'row-' + device.id"
                            >
                                <td>{{ device.manufacturer }}</td>
                                <td>{{ device.name }}</td>
                                <td>{{ device.display_name }}</td>
                                <td>
                                    <i
                                        :class="{
                                            'cus-accept':
                                                device.device_status ===
                                                'Online',
                                            'cus-error':
                                                device.device_status !==
                                                'Online'
                                        }"
                                    ></i>
                                    <span>
                                        {{ device.device_status }}
                                    </span>
                                </td>

                                <td class="text-right small text-nowrap">
                                    <div>
                                        <span
                                            style="cursor: pointer;"
                                            v-if="hasPermissionEdit"
                                            @click="editDevice(device)"
                                            >Edit</span
                                        >
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="9">
                                <i>No records available</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div>
            <modal-edit-device
                ref="modalEditDevice"
                @onsuccess="getDeviceList()"
            />
            <modal-add-device
                v-if="hasPermissionAdd && isStripeExtensionEnabled"
                ref="modalAddDevice"
                @onsuccess="getDeviceList()"
            />
        </div>
    </div>
</template>

<script>
import Payment from "@/services/payment";
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Spinner: () => import("@/components/elements/spinner.vue"),
        modalEditDevice: () =>
            import("@/components/payments/device/modal-edit-device.vue"),
        ModalAddDevice: () =>
            import("@/components/payments/device/modal-add-device.vue")
    },
    data() {
        return {
            isLoading: false,
            devices: [],
            isAddonEnable: false,
            isLoadingAddModal: false,
            isLoadingSyncModal: false
        };
    },
    computed: {
        hasPermissionAdd() {
            return this._hasAccess("setting.device.add");
        },
        hasPermissionEdit() {
            return this._hasAccess("setting.device.edit");
        },
        isStripeExtensionEnabled() {
            return this._isExtensionEnabled(EXTENSIONS.CODE.CODE_STRIPE);
        }
    },
    created() {
        this.getDeviceList();
    },
    methods: {
        async getDeviceList() {
            let self = this;
            self.isLoading = true;
            this._getSetting().then(() => {
                this.$nextTick(async () => {
                    if (self.isStripeExtensionEnabled) {
                        self.isAddonEnable = true;
                        await Payment.getStripeDeviceList().then(response => {
                            if (response.code == 200) {
                                self.devices = response.description;
                            }
                        });
                    } else if (
                        self._isExtensionEnabled(EXTENSIONS.CODE.CODE_CCONNECT)
                    ) {
                        self.isAddonEnable = true;
                        await Payment.getCConnectDeviceList().then(response => {
                            if (response.code == 200) {
                                self.devices = response.description;
                            }
                        });
                    }
                    self.isLoading = false;
                });
            });
        },
        editDevice(device) {
            this.$refs.modalEditDevice.open(device);
        },
        openAddDevice() {
            this.$refs.modalAddDevice.open();
        }
    }
};
</script>

<style scoped>
.btn {
    background-color: #e1e1e1;
    width: 100px;
    margin-right: 5px;
}
</style>
